var map = {
	"./site-logo-desktop-footer.svg": 69110,
	"./site-logo-desktop.svg": 51694,
	"./site-logo-drawer-mobile.svg": 44372,
	"./site-logo-drawer.svg": 29497,
	"./site-logo-mobile-drawer.svg": 19806,
	"./site-logo-mobile.svg": 11924,
	"./site-logo-sm.svg": 68966,
	"./site-logo-tv.svg": 7580,
	"./site-logo-wrapper-mobile-scrolled.svg": 23711,
	"./site-logo-wrapper-mobile.svg": 18718,
	"./site-logo-wrapper-scrolled.svg": 74976,
	"./site-logo-wrapper.svg": 48271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99526;